const YOUTUBE_API_KEY = import.meta.env.VITE_YOUTUBE_API_KEY;

export const fetchYouTubePlaylistTracks = async (playlistId) => {
    const tracks = [];
    let pageToken = undefined;
    let videoIdList = [];
  
    console.log('Fetching YouTube playlistId:', playlistId);
    try {
      do {
        const url = `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=${playlistId}&maxResults=50${pageToken ? `&pageToken=${pageToken}` : ""}&key=${YOUTUBE_API_KEY}`;
        const res = await fetch(url);
        const data = await res.json();

        console.log('data', data)
  
        if (!data.items) {
          if (data.error && data.error.code === 404) {
            console.error(`YouTube API error: Playlist not found. playlistId: ${playlistId}`);
          } else {
            console.error("YouTube API error:", data); 
          }
          break;
        }

        // Collect videoIds for batch duration fetch
        const ids = data.items.map((item) => item.snippet.resourceId.videoId).filter(Boolean);
        videoIdList.push(...ids);

        tracks.push(
          ...data.items.map((item) => ({
            title: item.snippet.title,
            videoId: item.snippet.resourceId.videoId,
            thumbnail: item.snippet.thumbnails?.default?.url || null,
          }))
        );
  
        pageToken = data.nextPageToken;
      } while (pageToken);

      // Fetch durations in batches of 50
      const getDurations = async (videoIds) => {
        if (videoIds.length === 0) return {};
        const batches = [];
        for (let i = 0; i < videoIds.length; i += 50) {
          batches.push(videoIds.slice(i, i + 50));
        }
        const durationMap = {};
        for (const batch of batches) {
          const url = `https://www.googleapis.com/youtube/v3/videos?part=contentDetails&id=${batch.join(",")}&key=${YOUTUBE_API_KEY}`;
          const res = await fetch(url);
          const data = await res.json();
          if (data.items) {
            data.items.forEach((item) => {
              durationMap[item.id] = parseISODuration(item.contentDetails.duration);
            });
          }
        }
        return durationMap;
      };

      // Helper to parse ISO 8601 duration to seconds
      function parseISODuration(isoDuration) {
        // Example: PT1H2M10S
        const regex = /PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/;
        const matches = isoDuration.match(regex);
        if (!matches) return 0;
        const hours = parseInt(matches[1] || "0", 10);
        const minutes = parseInt(matches[2] || "0", 10);
        const seconds = parseInt(matches[3] || "0", 10);
        return hours * 3600 + minutes * 60 + seconds;
      }

      const durationMap = await getDurations(videoIdList);
      // Add duration to each track
      tracks.forEach((track) => {
        track.duration = durationMap[track.videoId] || 0;
      });
    } catch (err) {
      console.error("fetchYouTubePlaylistTracks failed:", err);
    }
  
    return tracks;
  };
